import React from 'react';
import { Button, ButtonOrLinkProps } from '../../Button';
import {
	ButtonGroupButton,
	ButtonGroupButtonProps,
} from '../../ButtonGroupButton';

export type ButtonBarButtonProps = {
	buttonText: string;
	buttonProps:
	| ( ButtonOrLinkProps & {
		isIconWhenSmall?: boolean;
		isVisible?: boolean;
		  } )
	| ( ButtonGroupButtonProps & {
		isIconWhenSmall?: boolean;
		isVisible?: boolean;
		  } );
	isMobile: boolean;
	isAnyButtonLoading: boolean;
	clickedButtonKey?: string;
	setClickedButtonKey: ( buttonText: string ) => void;
};

export const ButtonBarButton: React.FC<ButtonBarButtonProps> = ( {
	buttonText,
	buttonProps,
	isMobile,
	isAnyButtonLoading,
	clickedButtonKey,
	setClickedButtonKey,
} ) => {
	const {
		isVisible,
		isIconWhenSmall,
		className,
		startIcon,
		...refinedButtonProps
	} = buttonProps;
	return isVisible ? (
		'options' in refinedButtonProps ? (
			<ButtonGroupButton
				{ ...refinedButtonProps }
				startIcon={
					startIcon && isMobile && isIconWhenSmall ? startIcon : undefined
				}
				disabled={
					refinedButtonProps.disabled ||
					( isAnyButtonLoading && clickedButtonKey !== buttonText )
				}
				buttonProps={ {
					onClick: ( e ) => {
						setClickedButtonKey( buttonText );
						refinedButtonProps.buttonProps?.onClick?.( e );
					},
				} }
			>
				{ isMobile && isIconWhenSmall ? null : buttonText }
			</ButtonGroupButton>
		) : !( 'href' in refinedButtonProps ) ? (
			// Its a button
			<Button
				{ ...refinedButtonProps }
				// only icons when on mobile and only showing icons
				startIcon={
					startIcon && isMobile && isIconWhenSmall ? startIcon : undefined
				}
				disabled={
					refinedButtonProps.disabled ||
					( isAnyButtonLoading && clickedButtonKey !== buttonText )
				}
				onClick={ ( e ) => {
					setClickedButtonKey( buttonText );
					refinedButtonProps.onClick?.( e );
				} }
			>
				{ isMobile && isIconWhenSmall ? null : buttonText }
			</Button>
		) : (
			// it's a link - so no loading or disabled values
			<Button
				{ ...refinedButtonProps }
				startIcon={
					startIcon && isMobile && isIconWhenSmall ? startIcon : undefined
				}
				disabled={
					refinedButtonProps.disabled ||
					( isAnyButtonLoading && clickedButtonKey !== buttonText )
				}
			>
				{ isMobile && isIconWhenSmall ? null : buttonText }
			</Button>
		)
	) : null;
};
